import React, { useState } from "react";
import axios from "axios";



import logo from "../../images/logo-01.svg";
import { urls } from "../../config";
import CenterColumn from "../../components/CenterColumn";
import { Input, Text, Button } from "../../components/ui";
import Container from "../../components/Container";
// import moodleLogo from "../../images/logo.svg";



const Page = ({ rootPath }: { rootPath: string }) => {
    const [email, setEmail] = useState("");

    const [error, setError] = useState("");
    const [finished, setFinished] = useState(false);
    const [loading, setLoading] = useState(false);


    const submitReset = (ev) => {
        ev.preventDefault();
        setError("");
        if (email === "") {
            setError("Email is required.");
            return;
        }
        setLoading(true);
        axios.post(`${urls.remoteURL}users/forgot-password`, { email })
            .then((x) => {
                setFinished(true);
            })
            .catch((err) => {
                setError("Email not found, please check and try again.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Container classes={['content-center', 'items-center']}>
            <CenterColumn wrapClasses={['bg-gray-100', 'py-4', 'lg:py-12']}>
                <div className="flex flex-col md:flex-row ">
                    <div className="flex-1 text-center">
                        <img src={logo} className="px-8" alt="Nail Knowledge" />
                    </div>
                    <div className="w-5/6 md:w-auto block md:flex-1 self-center">
                        {!finished ?
                            <form onSubmit={submitReset} className={`w-full p-4`}>
                                <Text className={`text-3xl`}>Lost your Password?</Text>
                                <Text className={`text-sm mb-2 font-extralight`}>Please enter your email address. You will receive an email message with instructions on how to reset your password.</Text>
                                <Input
                                    type="email"
                                    name="email"
                                    // mb={3}
                                    disabled={loading}
                                    value={email}
                                    error={error}
                                    placeholder="Enter your email address..."
                                    onChange={(ev) => setEmail(ev.target.value)}
                                />
                                {/* {error && (<p className={`flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1`}>{error}</p>)} */}
                                <Button type="submit" classes={['mt-4 self-end w-full rounded']} disabled={loading} bgColor="bg-nailBlue-600" bgHoverColor="bg-nailBlue-700">Reset Password</Button>
                            </form>
                            : <Text className={`text-3xl`}>Check your email for the confirmation link</Text>}
                    </div>

                </div>
            </CenterColumn>
        </Container>
    );
};

export default Page;